import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthForm } from './components/AuthForm';
import { DashboardLayout } from './components/DashboardLayout';
import { Dashboard } from './components/Dashboard';
import { EmailGenerator } from './components/EmailGenerator';
import { ProfessorSearch } from './components/ProfessorSearch';
import { ProfessorRepliesPage } from './components/ProfessorRepliesPage';
import { Home } from './components/Home';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { GmailCallback } from './components/GmailCallback';
import { FloatingResearchAssistant } from './components/FloatingResearchAssistant';
import { CheckoutForm } from "./components/CheckoutForm";
import { GmailContext, origStatus } from "./lib/gmailcontext";
import { PricingPage } from './components/PricingPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.style.scrollBehavior = 'auto';
    
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    return () => {
      document.body.style.scrollBehavior = '';
    };
  }, [pathname]);
  
  return null;
}

export default function App() {
  const [gmailStatus, setGmailStatus] = useState(origStatus);

    // Setup Gmail at top level
    useEffect(() => {
      const gapiscript = document.createElement('script');
      gapiscript.src = "https://apis.google.com/js/api.js";
      document.head.appendChild(gapiscript);
      gapiscript.onload = () => {
        console.log("gapi loaded");
        window.gapi.load('client', () => {
          window.gapi.client.init({
              apiKey: import.meta.env.VITE_GOOGLE_APIKEY,
              discoveryDocs: ["https://gmail.googleapis.com/$discovery/rest?version=v1"]
          }).then(() => {
              setGmailStatus(Object.defineProperty(gmailStatus, "gapiLoaded", {value: true}));
          });
      });
      };
  
      const gsiscript = document.createElement('script');
      gsiscript.src = "https://accounts.google.com/gsi/client";
      document.head.appendChild(gsiscript);
      gsiscript.onload = () => {
        setGmailStatus(Object.defineProperty(gmailStatus, "gsiLoaded", {value: true}));
      }
    }, [])



  return (
    <Router>
      <ScrollToTop /> 
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <GmailContext.Provider value={[gmailStatus, setGmailStatus]}>
        <main className="flex-grow">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<AuthForm type="login" />} />
            <Route path="/signup" element={<AuthForm type="signup" />} />
            <Route path="/pay" element={<CheckoutForm/>} />
            <Route path="/auth/google/callback" element={<GmailCallback />} />

            {/* Protected routes */}
            <Route path="/dashboard" element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            } />
            <Route path="/search" element={
              <DashboardLayout>
                <ProfessorSearch />
              </DashboardLayout>
            } />
            <Route path="/emails" element={
              <DashboardLayout>
                <EmailGenerator />
              </DashboardLayout>
            } />
            <Route path="/replies" element={
              <DashboardLayout>
                <ProfessorRepliesPage />
              </DashboardLayout>
            } />
            <Route path="/pricing" element={<PricingPage />} />
            {/* <Route path="/profile" element={
              <DashboardLayout>
              <ProfileSettings />
              </DashboardLayout>
              } /> */}

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        </GmailContext.Provider>
        <Footer />
        <FloatingResearchAssistant />
      </div>
    </Router>
  );
}